// extracted by mini-css-extract-plugin
export default {"nav":"header_nav__4IG-V","wrapper":"header_wrapper__wInC+","logo":"header_logo__OQjfj","link":"header_link__hTLIZ"};